import React from 'react';
import { ArrowRight, CheckCircle, Download, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';
import { complianceDocs as fallbackComplianceDocs, standards } from '../data/siteData';
import { getContentIcon, useCollectionData } from '../services/contentApi';
import './Compliance.css';

const Compliance = () => {
  const { items: complianceDocs } = useCollectionData('complianceDocs', fallbackComplianceDocs);

  return (
  <>
    <section className="page-hero compliance-hero">
      <div className="container page-hero-grid">
        <div>
          <p className="eyebrow">Compliance</p>
          <h1 className="page-title">Every linen program needs audit-ready standards.</h1>
        </div>
        <p className="page-kicker">
          Non-compliant healthcare linen handling can create infection risk,
          staff exposure, regulatory fines, and contract problems. NovaCareLinens
          keeps material standards and account documentation ready.
        </p>
      </div>
    </section>

    <section className="section compliance-main">
      <div className="container compliance-layout">
        <aside className="compliance-aside surface-card">
          <span className="icon-circle tone-emerald">
            <Lock size={22} strokeWidth={1.8} aria-hidden="true" />
          </span>
          <h2>Compliance-first promise</h2>
          <p>
            We partner with accredited processing networks and maintain
            documentation that supports procurement, infection prevention,
            and quality teams.
          </p>
          <div className="download-list">
            <h3>Downloadable resources</h3>
            {complianceDocs.map((doc, index) => {
              const Icon = getContentIcon(doc.icon);
              return (
                <a href={doc.href || doc.fileUrl} download className="download-item" key={doc.title || index}>
                  <Icon size={18} strokeWidth={1.8} aria-hidden="true" />
                  <span>{doc.title}</span>
                  <Download size={17} aria-hidden="true" />
                </a>
              );
            })}
          </div>
          <Link className="btn-primary" to="/contact">
            Request documentation <ArrowRight size={18} aria-hidden="true" />
          </Link>
        </aside>

        <div className="standards-grid">
          {standards.map(({ code, full, Icon, tone, points }, index) => (
            <article className="standard-card stagger-card" key={code} style={{ '--delay': `${index * 90}ms` }}>
              <div className="standard-head">
                <span className={`icon-circle tone-${tone}`}>
                  <Icon size={24} strokeWidth={1.8} aria-hidden="true" />
                </span>
                <div>
                  <h2>{code}</h2>
                  <p>{full}</p>
                </div>
                <span className="standard-status">Compliant</span>
              </div>
              <ul className="check-list">
                {points.map((point) => (
                  <li key={point}>
                    <CheckCircle size={16} aria-hidden="true" />
                    {point}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  </>
  );
};

export default Compliance;
